module.exports = __webpack_public_path__ + "static/media/Boomiger.18651030.png";